module.exports = __webpack_public_path__ + "static/img/pinpai-2.f16d330c.png";